import { PauseIcon, SkipNextIcon, SkipPrevIcon, PlayIcon } from "../Svg";
import styled, { css, keyframes } from "styled-components";

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0); /* Initial and final position */
  }
  40% {
    transform: translateY(-20px); /* Bounce up */
  }
  60% {
    transform: translateY(-10px); /* Bounce down */
  }
`;

export const BarTime = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 10px;
`;
export const Times = styled.div`
  color: #ffffffb8;
  font-size: 12px;
`;
export const MusicButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 65px;
  position: relative;
`;
export const Prev = styled(SkipPrevIcon)`
  height: 45px;
  color: #4b4544;
`;
export const Pause = styled(PauseIcon)`
  height: 50px;
  background-color: white;
  color: black;
  border-radius: 100%;
  padding: 10px;
  cursor: pointer;
`;
export const Play = styled(PlayIcon)`
  height: 50px;
  background-color: white;
  color: black;
  border-radius: 100%;
  padding: 10px;
  cursor: pointer;
`;
export const Next = styled(SkipNextIcon)`
  height: 45px;
  color: #4b4544;
`;
export const Edit = styled.div`
  svg {
    color: white;
    height: 20px;
  }
  position: absolute;
  right: -50px;
  cursor: pointer;
  animation: ${({ showAnimation }) =>
    showAnimation
      ? css`
          ${bounce} 1s infinite
        `
      : "none"};
  &:hover,
  &:focus {
    animation: none;
  }
`;
